module.exports = __webpack_public_path__ + "05a6fa251b65782d22b6750fcf5e29e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-08-harrison-yoga/3.jpg
// module id = 612
// module chunks = 0